import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { SessionProvider } from './auth/SessionContext';
import { routes } from './routes';

const router = createBrowserRouter(routes);

/**
 * `SessionProvider` wraps the router rather than living inside the layout, so
 * "who am I" is asked once per page load and not once per navigation.
 */
export function App(): React.JSX.Element {
  return (
    <SessionProvider>
      <RouterProvider router={router} />
    </SessionProvider>
  );
}
